import React from 'react';

import { Button } from 'react-bootstrap'

export default class LoginButton extends React.Component {
   render() {
      if (this.props.buttonLabel !== undefined) {
         return <Button variant="light" className="focus-ring shadow-boxed-button" style={{color: '#3674ab', fontWeight: 'bold', boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.4), 0 6px 20px 0 rgba(0, 0, 0, 0.39)" }} type="submit" disabled={this.props.disabled}>{this.props.buttonLabel}</Button>
      }
      return (
         <Button variant="light" style={{color: '#3674ab', fontWeight: 'bold', boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.4), 0 6px 20px 0 rgba(0, 0, 0, 0.39)" }} type="submit" disabled={this.props.disabled} >Submit</Button>
      )
   }
}


